import { type FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faRocket } from '@fortawesome/free-solid-svg-icons';

const DeploymentReadinessMock: FC = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3 space-y-3">
      {/* Research pipeline status */}
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4">
        <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-3">
          Deployment Readiness
        </h4>
        <div className="space-y-2">
          {[
            { stage: 'Strategy Code', status: 'Validated', version: 'v3', color: 'text-emerald-400' },
            { stage: 'Baseline Backtest', status: '161 trades', version: 'Sharpe 1.24', color: 'text-emerald-400' },
            { stage: 'Parameter Optimization', status: 'Stable region', version: '0.87 stability', color: 'text-emerald-400' },
            { stage: 'Cross-Asset Validation', status: '3/4 assets passed', version: '', color: 'text-emerald-400' },
            { stage: 'Walk-Forward Analysis', status: '4/5 windows passed', version: 'WFE 72%', color: 'text-emerald-400' },
          ].map((item) => (
            <div key={item.stage} className="flex items-center gap-3 px-3 py-2 rounded bg-white/[0.02]">
              <FontAwesomeIcon icon={faCheckCircle} className={`text-sm ${item.color}`} />
              <span className="text-sm text-gray-300 flex-1">{item.stage}</span>
              <span className="text-[10px] text-gray-400">{item.status}</span>
              {item.version && <span className="text-[10px] text-gray-500">{item.version}</span>}
            </div>
          ))}
        </div>
      </div>

      {/* Deployed config */}
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4">
        <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-3">
          Deployed Configuration
        </h4>
        <div className="grid grid-cols-2 gap-2">
          {[
            { label: 'Strategy', value: 'EMA Crossover v3' },
            { label: 'Asset', value: 'BTCUSDT' },
            { label: 'Interval', value: '4h' },
            { label: 'Parameters', value: 'fast:34, slow:40' },
          ].map((item) => (
            <div key={item.label} className="px-2 py-1.5">
              <div className="text-[9px] text-gray-500 uppercase tracking-wider">{item.label}</div>
              <div className="text-sm text-gray-300">{item.value}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Enable button */}
      <div className="flex items-center justify-center gap-2 px-4 py-2.5 bg-cyan-600 text-white rounded-lg text-sm font-medium">
        <FontAwesomeIcon icon={faRocket} />
        Enable Adaptive Flow Monitoring
      </div>
    </div>
  </div>
);

export default DeploymentReadinessMock;
